import ApplicantManual from '@/components/services/StorageIssue/Applicant/Manual/index.vue';

import StorageFile from '@/components/services/StorageIssue/StorageFile.vue';
import AccountBankDetails from '@/components/services/StorageIssue/AccountBankDetails.vue';
import StepDocuments from '@/components/services/common/StepDocuments.vue';

import SelectSubjectFillType from '@/components/services/common/SelectSubjectFillType.vue';
import SubjectFillType from '@/components/services/common/SubjectFillType.vue';

import { isMrpaEnable } from '@/app.config';
import { StatementType } from '@/constants';

const commonSteps: unknown[] = [StorageFile, AccountBankDetails, StepDocuments];
const steps: unknown[] = [ApplicantManual, ...commonSteps];

const mrpaSteps: unknown[] = [
  SelectSubjectFillType,
  SubjectFillType,
  ...commonSteps,
];

export const storageIssueSteps: unknown[] = isMrpaEnable(StatementType.STORAGE_ISSUE) ? mrpaSteps : steps;
